<template>
    <!-- Componente para mostrar los modelos en el Home -->
    <div>
        <!-- Selector de categorías -->
        <div class="w-full mx-auto my-8 px-6 flex justify-center items-center">
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'autos' }"
                @click="changeCategory('autos')"
            >
                Autos
            </div>
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'suv' }"
                @click="changeCategory('suv')"
            >
                SUV
            </div>
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'hibridos' }"
                @click="changeCategory('hibridos')"
            >
                Híbridos
            </div>
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'electricos' }"
                @click="changeCategory('electricos')"
            >
                Eléctricos
            </div>
            <!--
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'especiales' }"
                @click="changeCategory('especiales')"
            >Especiales</div>
            -->
            <!-- <div class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue" :class="{'text-light-blue': activeCategory === 'comercial'}" @click="changeCategory('comercial')">Comerciales</div> -->
        </div>
        <!-- Slider de modelos -->
        <div class="sliders">
            <div
                v-for="(category, index) in categories"
                :key="index"
                v-show="activeCategory === index"
                class="max-w-screen-xl mx-auto flex justify-center items-center"
            >
                <button
                    @click="previous()"
                    class="cursor-pointer"
                    :class="{ hidden: !(activeCategoryLength > 1) }"
                    aria-label="Flecha izquierda"
                >
                    <i
                        class="border-solid border-black inline-block p-1 mr-1"
                        style="border-width: 0 2px 2px 0; transform: rotate(135deg)"
                    ></i>
                </button>
                <VueSlickCarousel class="w-11/12" :ref="'carousel-' + index" v-bind="slickOptions">
                    <div v-for="(model, index) in category" :key="index" class="px-6 w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
                        {{ ca }}
                        <a
                            class=""
                            :href="`${url}/${webpage}/modelos/configura-una-version/${model.slug.replaceAll('_', '-')}/f/${model.year}${activeCategory == 'especiales' ? '?type=especial' : ''}`"
                        >
                            <figure class="w-full h-40 flex justify-center items-center">
                                <img
                                    width="1600"
                                    height="590"
                                    class="w-full"
                                    :src="`${model.model_image}`"
                                    :alt="model.name"
                                />
                            </figure>
                            <div class="w-full">
                                <p class="text-xl lg:text-lg font-medium">
                                    {{ model.name }} <span class="font-sans">{{ model.year }}</span>
                                </p>
                                <div class="leading-tight">Desde ${{ formatPrice(model.initial_price) }}</div>
                            </div>
                        </a>
                    </div>
                </VueSlickCarousel>
                <button
                    @click="next()"
                    class="cursor-pointer"
                    :class="{ hidden: !(activeCategoryLength > 1) }"
                    aria-label="Flecha derecha"
                >
                    <i
                        class="border-solid border-black inline-block p-1 mr-1"
                        style="border-width: 0 2px 2px 0; transform: rotate(-45deg)"
                    ></i>
                </button>
            </div>
        </div>
        <a
            class="block w-64 lg:w-40 text-center bg-dark-blue text-white text-sm py-2 mx-auto mt-24 mb-10"
            :href="`${url}/${webpage}/modelos`"
            >Ver todo</a
        >
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
    components: { VueSlickCarousel },
    props: ["categories"],
    data() {
        return {
            // Variable para almacenar la url base del sitio
            url: $(".url").text(),
            // Variable para almacenar el slug del distribuidor
            webpage: $(".webpage").text(),
            // Variable para las opciones del slider de modelos
            slickOptions: {
                // centerMode: true,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 1,
                lazyLoad: "progressive",
                responsive: [
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 639,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                    // {
                    //     "breakpoint": 320,
                    //     "settings": {
                    //         "slidesToShow": 1,
                    //     }
                    // }
                ],
            },
            activeCategory: "autos",
        };
    },
    methods: {
        // Función para recorrer el slider hacía adelante
        next() {
            this.$refs[this.activeCarousel][0].next();
        },
        // Función para recorrer el slider hacía atrás
        previous() {
            this.$refs[this.activeCarousel][0].prev();
        },
        // Función para cambiar la categoría seleccionada
        changeCategory(category) {
            $(".sliders").fadeOut("fast", () => {
                this.activeCategory = category;
                $(".sliders").fadeIn("fast");
            });
        },
        // Función para formatear el precio
        formatPrice(price, n, x) {
            let re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
            return parseInt(price).toFixed(Math.max(0, ~~n)).replace(new RegExp(re, "g"), "$&,");
        },
    },
    computed: {
        // Retorna la clase de la categoría activa
        activeCarousel: function () {
            return "carousel-" + this.activeCategory;
        },
        // Retorna el número de modelos de la categoría activa
        activeCategoryLength: function () {
            return this.categories[this.activeCategory].length;
        },
    },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
